import { Button, Container, Flex } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useCompleteJobTask } from "@labeling-tools/api/lebron/react-query-hooks";
import { useParams } from "react-router-dom";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { useQueryClient } from "@tanstack/react-query";

export const ProductAssociationQaActions = ({
  task,
}: {
  task: JobTaskDetailSchema;
}) => {
  const { jobId } = useParams<{ jobId: string }>();
  const { mutateAsync: completeJobTask } = useCompleteJobTask(
    jobId || "",
    task.id || "",
  );
  const queryClient = useQueryClient();

  /**
   * handle incorrect - complete the task and invalidate the query client
   */
  const handleIncorrect = async () => {
    await completeJobTask({
      result: {
        qa_correct: false,
      },
    });
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
  };

  /**
   * handle correct - complete the task and invalidate the query client
   */
  const handleCorrect = async () => {
    await completeJobTask({
      result: {
        qa_correct: true,
      },
    });
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-4 transition-transform duration-300"
      style={{ transform: "translateY(0%)" }}
    >
      <Container size="lg">
        <Flex justify="center" gap="md">
          <Button
            size="md"
            className="min-w-[120px]"
            color="red"
            variant="subtle"
            onClick={handleIncorrect}
          >
            <IconX />
            Incorrect
          </Button>
          <Button size="md" className="min-w-[120px]" onClick={handleCorrect}>
            <IconCheck />
            Correct
          </Button>
        </Flex>
      </Container>
    </div>
  );
};
